if (document.querySelector('.completa-il-look .swiper')) {
    console.log('swiper');
    new Swiper('.completa-il-look .swiper', {
        slidesPerView: 1.5,
        breakpoints: {
            768: {
                slidesPerView: 2
            }
        }
    });
}